import {
	ADMINGETINTEGRATIONTYPELIST_SUCCESS,
	ADMINGETINTEGRATIONTYPELIST_FAILED,
	RESET_ADMINGETINTEGRATIONTYPELIST,
	LOADING_ADMINGETINTEGRATIONTYPELIST,
	NETWORK_ERROR_ADMINGETINTEGRATIONTYPELIST
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {},
	message: "",
	networkError: ""
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINGETINTEGRATIONTYPELIST:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {},
				message: "",
				networkError: ""
			};
		case ADMINGETINTEGRATIONTYPELIST_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case ADMINGETINTEGRATIONTYPELIST_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case NETWORK_ERROR_ADMINGETINTEGRATIONTYPELIST:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {},
				message: "",
				networkError: ""
			};
		case RESET_ADMINGETINTEGRATIONTYPELIST:
			return (state = initialState);
		default:
			return state;
	}
};
